import { render, staticRenderFns } from "./insurerStatement.vue?vue&type=template&id=2d62a3d9&scoped=true&"
import script from "./insurerStatement.vue?vue&type=script&lang=js&"
export * from "./insurerStatement.vue?vue&type=script&lang=js&"
import style0 from "./insurerStatement.vue?vue&type=style&index=0&id=2d62a3d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62a3d9",
  null
  
)

export default component.exports